import { Component, Input, OnInit } from '@angular/core';

export interface Descriptor {
  type?: 'string'|'boolean'|'integer'|'number'|'date'|'date-time'|'email'|'object'|'option';
  array?: boolean;
  domain?: any[];
  required?: boolean;
  targetField?:string;
  default?: any;
}

@Component({
  selector: 'app-data-importer-descriptor',
  templateUrl: './data-importer-descriptor.component.html',
  styleUrls: ['./data-importer-descriptor.component.scss']
})
export class DataImporterDescriptorComponent {

  @Input() input: Descriptor

  constructor() { }

}
